export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ08.a1cf7f13.mp3";